import { createContext, useContext } from 'react';
import { ResendMessageOptions } from '../types';

export interface EventHistoryModalsContextState {
  showResendMessageModal: (options: ResendMessageOptions) => void;
  resendMessageModalOptions: ResendMessageOptions | null;
  isResendMessageModalVisible: boolean;
  closeModal: () => void;
}

export const defaultState = {
  showResendMessageModal: () => null,
  resendMessageModalOptions: null,
  isResendMessageModalVisible: false,
  closeModal: () => null,
};

export const EventHistoryModalsContext =
  createContext<EventHistoryModalsContextState>(defaultState);

export const useEventHistoryModalsContext = () => useContext(EventHistoryModalsContext);
